var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6507 8.96317C11.6507 10.3874 10.4456 11.542 8.959 11.542C7.47243 11.542 6.26733 10.3874 6.26733 8.96317C6.26733 7.53893 7.47243 6.38438 8.959 6.38438C10.4456 6.38437 11.6507 7.53894 11.6507 8.96317ZM8.96387 3.59375C7.4247 3.60058 5.8293 3.97528 4.31903 4.69268C3.19768 5.24727 2.10487 6.02973 1.15625 6.99551C0.690338 7.48851 0.0960778 8.20236 0 8.96401C0.0113542 9.62376 0.719052 10.4381 1.15625 10.9325C2.04581 11.8604 3.11017 12.621 4.31903 13.2359C5.72742 13.9194 7.28631 14.313 8.96387 14.3348C10.5045 14.3279 12.0996 13.9489 13.6081 13.2359C14.7295 12.6813 15.8229 11.8983 16.7715 10.9325C17.2374 10.4395 17.8317 9.72565 17.9277 8.96401C17.9164 8.30425 17.2087 7.48988 16.7715 6.99548C15.8819 6.06763 14.817 5.3076 13.6081 4.69265C12.2005 4.00966 10.6378 3.61883 8.96387 3.59375ZM8.96274 4.9271C11.2951 4.9271 13.1858 6.73472 13.1858 8.96459C13.1858 11.1945 11.2951 13.0021 8.96274 13.0021C6.63035 13.0021 4.73963 11.1944 4.73963 8.96459C4.73963 6.73472 6.63035 4.9271 8.96274 4.9271Z",
    fill: "#548170"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpenIcon);
export default __webpack_public_path__ + "static/media/eye_open_icon.c53d0498ae5259e426219132bc3821f9.svg";
export { ForwardRef as ReactComponent };